export default (x) => x && x.toString().split('.')[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
